"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profile = void 0;
const ApiResponse_1 = require("../types/ApiResponse");
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a profile of the given account name. The profile includes an overall score and the distribution of incoming tokens within different categories.
 *
 * @param account EOS mainnet account name
 * @param threshold Minimum proportion of a transfer to be included in profiling (as percentage between `0.001` and `0.9`). Default is `0.01`
 *
 * @example
 *
 * Request a profile of the account `eosnationftw`:
 *
 * `const profile = await detective.profile("eosnationftw");`
 *
 * Response:
 *
 * ```
 * {
 *   account: 'eosnationftw',
 *   contract: 'eosio.token',
 *   token: 'EOS',
 *   total_tokens_received: 74747.4845,
 *   score: 87.3,
 *   categories: {
 *     system: {
 *       percentage: 0.9994754378657384,
 *       volume: 74708.2748,
 *       count: 205
 *     }
 *   }
 * }
 * ```
 */
function profile(account, threshold) {
    return __awaiter(this, void 0, void 0, function* () {
        if (threshold === undefined) {
            threshold = 0.01;
        }
        const queryParams = { account, threshold };
        try {
            const res = yield axios_1.default.request({
                url: "/profile",
                params: queryParams,
                transformResponse: (result) => {
                    const json = JSON.parse(result);
                    if (json.error) {
                        return new ApiResponse_1.ApiResponse(undefined, { code: json.code, errorMessage: json.errorMessage });
                    }
                    return new ApiResponse_1.ApiResponse(json.result);
                }
            });
            return yield res.data;
        }
        catch (err) {
            throw err.response.data;
        }
    });
}
exports.profile = profile;
//# sourceMappingURL=profile.js.map